import React from 'react';
import { mockData } from '../mock';
import Header from './Z_Header';
import HeroSlider from './Z_HeroSlider';
import ServicesSection from './Z_ServicesSection';
import ProjectsSection from './Z_ProjectsSection';
import ContactSection from './Z_ContactSection';
import BeschreibungSection from './Beschreibung';
import { Separator } from './ui/separator';

/**
 * EOS Parallel-Homepage (CI-clean)
 * - Keine Parallax-Sektionen
 * - Keine Template-Blue Highlights
 * - Ruhige Raster, klare Hierarchie
 */
const Homepage = () => {
  // Keine scrollY-Logik: kein Parallax / kein scroll-basiertes Transform.

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-eos-weißFast">
      {/* Header */}
      <Header scrollToSection={scrollToSection} />

      {/* Hero */}
      <HeroSlider scrollToSection={scrollToSection} company={mockData.company} />

     {/* Haltung / Prinzip */}
      <BeschreibungSection />

      {/* Services */}
      <ServicesSection services={mockData.services} scrollToSection={scrollToSection} dataBg="light" />

      {/* Projects */}
      <ProjectsSection mockData={mockData} />

      {/* Contact */}
      <ContactSection contact={mockData.contact} />

      {/* Footer */}
      <footer className="bg-eos-grauDunkel text-eos-weißFast">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <div className="h-12 w-48 bg-logo_weis bg-contain bg-no-repeat bg-left" aria-hidden="true" />
              <p className="mt-4 text-sm text-eos-weißFast/65">
                Planung und Umsetzung elektrotechnischer Anlagen. Durchdacht konzipiert. Dauerhaft betrieben.
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold tracking-wide">Leistungen</h4>
              <ul className="mt-4 space-y-2 text-sm text-eos-weißFast/65">
                <li>Elektrotechnik</li>
                <li>Photovoltaik</li>
                <li>Speicher & Energiemanagement</li>
                <li>Sicherheitstechnik</li>
                <li>Betrieb & Service</li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold tracking-wide">Navigation</h4>
              <ul className="mt-4 space-y-2 text-sm text-eos-weißFast/65">
                <li>
                  <button className="hover:text-eos-weißFast" onClick={() => scrollToSection('services')}>
                    Leistungen
                  </button>
                </li>
                <li>
                  <button className="hover:text-eos-weißFast" onClick={() => scrollToSection('projects')}>
                    Referenzen
                  </button>
                </li>
                <li>
                  <button className="hover:text-eos-weißFast" onClick={() => scrollToSection('about')}>
                    Über uns
                  </button>
                </li>
                <li>
                  <button className="hover:text-eos-weißFast" onClick={() => scrollToSection('contact')}>
                    Kontakt
                  </button>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold tracking-wide">Kontakt</h4>
              <div className="mt-4 space-y-2 text-sm text-eos-weißFast/65">
                <p>{mockData.contact.address}</p>
                <p>{mockData.contact.phone}</p>
                <p>{mockData.contact.email}</p>
              </div>
            </div>
          </div>

          <Separator className="my-8 bg-white/10" />

          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-eos-weißFast/55">
              © {new Date().getFullYear()} {mockData.company.name}. Alle Rechte vorbehalten.
            </p>
            <div className="flex gap-6 text-sm text-eos-weißFast/65">
              <a href="#" className="hover:text-eos-weißFast">Impressum</a>
              <a href="#" className="hover:text-eos-weißFast">Datenschutz</a>
              <a href="#" className="hover:text-eos-weißFast">AGB</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Homepage;
